export const config = {
    appname: 'devapp',
    app_id: '2439493236332961', // App ID
    facebook_app_id: '2439493236332961', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    api: 'api',
    bzbsUrl: 'https://api1servicecenter.buzzebees.com',
    bzbsModuleUrl: 'https://apimodule.buzzebees.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule.buzzebees.com',
    webShoppingCartUrl: 'https://shoppingcartservice.buzzebees.com',
    bzbsBlobUrl: 'https://buzzebees.blob.core.windows.net',
    miscUrl: 'https://misc.buzzebees.com',
    // ------------------ End Settings ---------------------

    // --------------------- Recaptcha ---------------------
    recaptchaSiteKey: "6LeSnaAmAAAAAM8nTr70vcd-gBwNnrv06XjpZz-6",

    webApi: '',

    firebase: {
        // apiKey: "",
        // authDomain: "",
        // databaseURL: "",
        // projectId: "",
        // storageBucket: "",
        // messagingSenderId: "",
        // appId: "",
        // measurementId: ""
    },
};
